import * as React from 'react';
import { Form, FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import TailwindModal from './Tailwind/TailwindModal';
import TailwindSelect from './Tailwind/TailwindSelect';
import TailwindInput from './Tailwind/TailwindInput';
import TailwindButton from './Tailwind/TailwindButton';
import apiService from '../services/ApiService';
import { getCookie, setCookie } from '../services/Cookies';

export default function NewScenarioModal({ modelScenarios, modelId, newScenarioModalOpen, setNewScenarioModalOpen, setCurrentScenario, setSocketUrl }) {

    const [chosenScenario, setChosenScenario] = useState("Blank");
    const [isCreating, setIsCreating] = useState(false);

    const formik = useFormik({
        initialValues: {
          name: "",
          source_scenario: "Blank",
        },
        onSubmit: values => {

        if (values.name.length && !isCreating) {
            setIsCreating(true);
            // @ts-ignore
            apiService.postModelScenario(values.name, modelId, (chosenScenario !== "Blank") ? chosenScenario.id : null).then(
                async(response) => {
                    if (response) {
                        const newScenario = await response.json()
                        modelScenarios.push(newScenario);
                        setCurrentScenario(newScenario);
                        setSocketUrl('/scenario_events/' + newScenario.id);
                        handleClose();

                        try {
                            const entity = JSON.parse(getCookie('entity'));
                            entity.modelScenarios = modelScenarios;
                            setCookie('entity', entity ? JSON.stringify(entity) : "")
                        } catch (e) {}
                    }
                    setIsCreating(false);
                }
            ).catch(() => setIsCreating(false));

        }
        },
      });

    const handleClose = () => {
        setNewScenarioModalOpen(false);
        formik.resetForm();
        setChosenScenario("Blank");
    }

    const handleChange = (value) => {
        setChosenScenario(value);
    }

    // Build options for TailwindSelect
    const selectOptions = [
        { value: "Blank", label: "blank", isItalic: true },
        ...modelScenarios.map(scenario => ({
            value: scenario,
            label: scenario.name
        }))
    ];

    return (
        <TailwindModal
            isOpen={newScenarioModalOpen}
            onClose={handleClose}
            title="New Scenario"
            size="md"
            footer={
                <div className="flex gap-3 justify-center w-full">
                    <TailwindButton
                        variant="secondary"
                        onClick={handleClose}
                        icon="close"
                        disabled={isCreating}
                    >
                        Cancel
                    </TailwindButton>
                    <TailwindButton
                        variant="primary"
                        onClick={() => formik.handleSubmit()}
                        icon="add"
                        disabled={isCreating}
                    >
                        {isCreating ? 'Creating...' : 'Add'}
                    </TailwindButton>
                </div>
            }
        >
            <div className="relative">
                {isCreating && (
                    <div className="absolute inset-0 z-10 flex items-center justify-center bg-white/70 rounded-lg">
                        <span className="material-symbols-outlined animate-spin text-[24px] text-slate-500">progress_activity</span>
                    </div>
                )}
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                        <div className="flex flex-col gap-4">
                            <TailwindSelect
                                label="From"
                                value={chosenScenario}
                                onChange={handleChange}
                                options={selectOptions}
                                disabled={isCreating}
                            />

                            <TailwindInput
                                label="Name"
                                type="text"
                                autoFocus
                                {...formik.getFieldProps("name")}
                                fullWidth
                                readOnly={isCreating}
                            />
                        </div>
                    </Form>
                </FormikProvider>
            </div>
        </TailwindModal>
    )

}
